
    var lange = "EN";
    
    function localStoreLang(lang)
    {
      	localStorage.setItem("language", lang);
    }
    
	// Set to show product details & product page
	function getProductLang()
	{
      	var lang = localStorage.getItem("language");
      
		var productTitle = document.getElementById("productTitleDiv");
      	var productDes = document.getElementById("productDesDiv");
      	var titleTab = document.getElementById("titleTabDiv");
      
      if(productTitle!=null && productDes!=null && titleTab!=null)
      {
       	productTitle = productTitle.innerHTML;
        productResult = productTitle.split("#");
        
        productDes = productDes.innerHTML;
        productDescResult = productDes.split("#");
        
        titleTab = titleTab.innerHTML;
        titleTabResult = titleTab.split("#");
     
    	//var productsTListitle = document.getElementById("productsTListitle").innerHTML;    
      	//var productsTListitleResult = productsTListitle.split("#");
      	if(lang=='TH')
        {
         	 productTitle = productResult[1];
         	 productDes = productDescResult[1];
          	 titleTab = titleTabResult[1];
        }
      	else
      	{
        	productTitle = productResult[0];
          	productDes = productDescResult[0];
          	titleTab = titleTabResult[0];
     	}
      	
     	document.getElementById("productTitle").innerHTML = productTitle;
    	document.getElementById("productDes").innerHTML = productDes;
	    document.getElementById("titleTab").innerHTML = titleTab;
       }
    }

	function collectionProducts(id,urlName)
	{
      	var lang = localStorage.getItem("language");
  		var productsLoop = document.getElementById(id).innerHTML; 
      
		if(productsLoop!=null)
      	{
        	productLoopResult = productsLoop.split("#");
       
			if(lang=='TH')
        	{
         	 	productsLoop = productLoopResult[1];
        	}
      		else
      		{
        		productsLoop = productLoopResult[0];
     		}
           document.getElementById(urlName).innerHTML = productsLoop;
        }
	}

	function myFunction(data)
  	{
		var lang = localStorage.getItem("language");
      
      	// Theme
		var searchID =  document.getElementById("search");
		var cartID = document.getElementById("cart");
		var menuToggle = document.getElementById("menu-toggle");
		var lastestNew = document.getElementById("lastestNew");
		var quickLink = document.getElementById("quickLink"); 
		var followUs = document.getElementById("followUs");
      
      	// Menu
        var homeMenu = document.getElementById("/");
        var catalogMenu = document.getElementById("/collections/all");
        var blogMenu = document.getElementById("/blogs/news");
        var aboutUsMenu = document.getElementById("/pages/about-us");
      
      if(lang=='TH')
		{
			searchID.placeholder = data.layout.search;
			cartID.innerHTML = data.layout.cart;
			menuToggle.innerHTML = data.layout.menu;
          
			lastestNew.innerHTML = data.footer.latest_news;
			quickLink.innerHTML = data.footer.quick_links;
			followUs.innerHTML = data.footer.follow_us;
          
          	homeMenu.innerHTML = data.mainMenu.home;
          	catalogMenu.innerHTML = data.mainMenu.catalog;
         	blogMenu.innerHTML = data.mainMenu.blog;
         	aboutUsMenu.innerHTML = data.mainMenu.about_us; 
          
           }

        getProductLang();
      
    }

